 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		95: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		95: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"CrossBorderProtectWithUpgrade","42":"Debug","43":"EMAPortal","44":"EarlyProtect360","45":"EarlyProtect360.Dashboard","46":"EarlyProtect360.Details","47":"EarlyProtect360Plus","48":"EarlyProtect360Plus.Dashboard","49":"EarlyProtect360Plus.Details","50":"FamilyProtect360","51":"FamilyProtectLiteWithUpgrade","52":"FilipinoBond","53":"FlashPayShieldWithUpgrade","54":"FraudProtect360","55":"HIProtect360Protect360","56":"HomeProtect360","57":"HomeProtectLite","58":"HomeSafe","59":"HomeStarterKit","60":"InternalDemoCookie","61":"KeymanProtect360","62":"KeymanProtect360.Dashboard","63":"KeymanProtect360.Details","64":"LeadForm","65":"Loan Protect 360 Renewal","66":"LoanProtect360","67":"LoanProtect360.Dashboard","68":"LoanProtect360.Details","69":"MaidProtect360","70":"MotoringCardShieldWithUpgrade","71":"Motorshow2020","72":"PartnerProgram","73":"PhoneProtect360","74":"PowerAgentPortal","75":"Prestige","76":"Prestige.Secured","77":"PublicHousingAssured","78":"ReviewUs","79":"SBSTPAProtectLite","80":"SBSTPAProtectPlus","81":"SBSTTravelInsurance","82":"SOA","83":"SimplyGo","84":"SingaporeTravelPass","85":"Touristcard","86":"TravelAssured","87":"TravelAssuredPlus","88":"TravelProtect360","89":"TravelProtect360Plus","90":"cileadform","91":"currencyconverter","92":"freehomeinsurance","94":"motorshow","96":"transferprotect360pro","97":"vCashCard","98":"weather"}[chunkId]||chunkId) + "." + {"0":"d5a10285","1":"bea7b942","2":"19c269e5","3":"c1fc0dc9","4":"45bc68da","5":"92522b9b","6":"b553612c","7":"10f1548d","8":"42041d59","9":"c178fe6a","10":"2c4a8e4f","11":"7a0a7f0c","12":"c50cf97b","13":"ade2e261","14":"e3ed1794","15":"8be80d03","16":"eb1e6779","17":"6981e2c5","18":"72a9d40f","19":"276bdb48","20":"56508bf4","21":"36faed29","22":"c4ee1120","23":"e492c08a","24":"2cd1d3b7","25":"00c9c7f8","26":"a6a2d106","27":"892f7600","28":"2a6b292e","29":"42a0e7d5","30":"53ee88eb","31":"c415c5ec","32":"1e8b6d16","33":"9c4afd8d","34":"604ad206","35":"4bf85e7b","36":"39b5bf59","37":"23c03a3a","38":"91a4982a","39":"a30cb7b9","40":"9db5020d","41":"8ce5104b","42":"a3f8cb4b","43":"8ecb3c16","44":"32cb3923","45":"32187fd6","46":"413c58fc","47":"78a1e933","48":"9b20734c","49":"a414177e","50":"c58adb4f","51":"38d2c902","52":"34484225","53":"77e02b57","54":"d8a88ebd","55":"b20056b1","56":"394e5641","57":"93722eb9","58":"def0798b","59":"d87947a5","60":"f832ed15","61":"69c261f8","62":"b46ff654","63":"5acdbbf2","64":"aa1c492e","65":"a3f0981a","66":"54ac55ed","67":"c01c76d8","68":"ddf6a67f","69":"05a98661","70":"f785ae96","71":"41a5ccf4","72":"fd0317d8","73":"46f8091f","74":"d5229468","75":"d771aa34","76":"4169d6eb","77":"e55de12d","78":"5965fc2e","79":"db3f7c8a","80":"edcb3f39","81":"6850851a","82":"6d32c04a","83":"f869e1cb","84":"c2614bcf","85":"9f9b6c72","86":"bbab15dd","87":"8f2cb7c3","88":"3691cd48","89":"df265793","90":"0330f1be","91":"07095656","92":"58090e35","94":"c339cc47","96":"d6b9188a","97":"cee68e08","98":"c4e64c08","100":"d1e74b0b","101":"21b8adbb","102":"827139a3","103":"3dde8819","104":"9a1bf621","105":"c511a9e8","106":"8066c56c","107":"3ee0c369","108":"6341f695","109":"6fc521e5","110":"fdd1041b","111":"dcec7557","112":"0d1dc51d","113":"eb814776","114":"ad154543","115":"1428b134","116":"3938430e","117":"bb822e9d","118":"e30f4532","119":"a4fd5da2","120":"6e898b77","121":"4371565f","122":"e866cfd8","123":"ebf14a92","124":"5a3402dc","125":"c45e0704","126":"3572166d","127":"768a6199","128":"aec12d27","129":"68b34695","130":"bd9127b8","131":"411a13e8","132":"16854303","133":"3f4318d5","134":"affabadc","135":"44d5ce97","136":"cd646a1f","137":"9c082c51","138":"311ee442","139":"80049d0d","140":"768f26ef","141":"4fe53256","142":"17cc1d9a","143":"c44b2c31","144":"5bf223cd","145":"e210e240","146":"1eedf4d4","147":"71a85f3d","148":"152aecfd","149":"23d90c6f","150":"905c17d1","151":"00d7293a","152":"b97f4718","153":"c6d72e09","154":"733f7d67","155":"318786fa","156":"05473525","157":"a1fa4227","158":"7b2dca83","159":"58f8c641","160":"d7d0a071","161":"2af76735","162":"d65f9413","163":"cebda8e0","164":"a0ce57ca","165":"67438ee5","166":"e2ec5df4","167":"91bb82b3","168":"e76d725c","169":"b5f68c5b","170":"09b94ef7","171":"ae04efc4","172":"f330650f","173":"2452aa0f","174":"e2d14208","175":"8f37a39e","176":"e8b025cb","177":"ddc655f7","178":"dc4d4c06","179":"6679cc08","180":"71fd6ca2","181":"78a5b7b4"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1,"21":1,"22":1,"23":1,"25":1,"28":1,"30":1,"31":1,"32":1,"33":1,"34":1,"37":1,"38":1,"40":1,"41":1,"42":1,"44":1,"47":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"61":1,"64":1,"69":1,"70":1,"72":1,"73":1,"74":1,"75":1,"76":1,"77":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"90":1,"91":1,"92":1,"94":1,"96":1,"97":1,"98":1,"101":1,"102":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"110":1,"111":1,"112":1,"113":1,"116":1,"120":1,"124":1,"125":1,"129":1,"130":1,"134":1,"135":1,"136":1,"137":1,"138":1,"139":1,"140":1,"141":1,"142":1,"143":1,"144":1,"145":1,"146":1,"147":1,"159":1,"160":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"CrossBorderProtectWithUpgrade","42":"Debug","43":"EMAPortal","44":"EarlyProtect360","45":"EarlyProtect360.Dashboard","46":"EarlyProtect360.Details","47":"EarlyProtect360Plus","48":"EarlyProtect360Plus.Dashboard","49":"EarlyProtect360Plus.Details","50":"FamilyProtect360","51":"FamilyProtectLiteWithUpgrade","52":"FilipinoBond","53":"FlashPayShieldWithUpgrade","54":"FraudProtect360","55":"HIProtect360Protect360","56":"HomeProtect360","57":"HomeProtectLite","58":"HomeSafe","59":"HomeStarterKit","60":"InternalDemoCookie","61":"KeymanProtect360","62":"KeymanProtect360.Dashboard","63":"KeymanProtect360.Details","64":"LeadForm","65":"Loan Protect 360 Renewal","66":"LoanProtect360","67":"LoanProtect360.Dashboard","68":"LoanProtect360.Details","69":"MaidProtect360","70":"MotoringCardShieldWithUpgrade","71":"Motorshow2020","72":"PartnerProgram","73":"PhoneProtect360","74":"PowerAgentPortal","75":"Prestige","76":"Prestige.Secured","77":"PublicHousingAssured","78":"ReviewUs","79":"SBSTPAProtectLite","80":"SBSTPAProtectPlus","81":"SBSTTravelInsurance","82":"SOA","83":"SimplyGo","84":"SingaporeTravelPass","85":"Touristcard","86":"TravelAssured","87":"TravelAssuredPlus","88":"TravelProtect360","89":"TravelProtect360Plus","90":"cileadform","91":"currencyconverter","92":"freehomeinsurance","94":"motorshow","96":"transferprotect360pro","97":"vCashCard","98":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"a858c2f5","20":"31d6cfe0","21":"a858c2f5","22":"86c9f98d","23":"d30bc41f","24":"31d6cfe0","25":"d33f62d9","26":"31d6cfe0","27":"31d6cfe0","28":"58058363","29":"31d6cfe0","30":"05f863ac","31":"ddf1f108","32":"04bc7233","33":"ddf1f108","34":"d33f62d9","35":"31d6cfe0","36":"31d6cfe0","37":"0e4fba13","38":"978e5247","39":"31d6cfe0","40":"ac3f861f","41":"0e4fba13","42":"5d27deaa","43":"31d6cfe0","44":"58058363","45":"31d6cfe0","46":"31d6cfe0","47":"58058363","48":"31d6cfe0","49":"31d6cfe0","50":"ddf1f108","51":"0e4fba13","52":"ddf1f108","53":"0e4fba13","54":"ddf1f108","55":"ddf1f108","56":"471a3a57","57":"471a3a57","58":"471a3a57","59":"0e4fba13","60":"31d6cfe0","61":"58058363","62":"31d6cfe0","63":"31d6cfe0","64":"dd9a60e3","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"14284125","70":"0e4fba13","71":"31d6cfe0","72":"8b647349","73":"471a3a57","74":"716aad65","75":"2fc531d7","76":"cdec5a50","77":"471a3a57","78":"31d6cfe0","79":"39dd3a27","80":"e81d10c5","81":"86c9f98d","82":"d33f62d9","83":"98c15efc","84":"2e8fdc12","85":"344cc04e","86":"86c9f98d","87":"86c9f98d","88":"2e8fdc12","89":"86c9f98d","90":"22b92479","91":"7b4f34de","92":"0e4fba13","94":"49234f01","96":"14284125","97":"94b03ce8","98":"23255cb6","100":"31d6cfe0","101":"cce35a68","102":"440606be","103":"31d6cfe0","104":"2d576837","105":"166c8acc","106":"db5d06da","107":"f93319e8","108":"f93319e8","109":"72c6f688","110":"72c6f688","111":"72c6f688","112":"f93319e8","113":"72c6f688","114":"31d6cfe0","115":"31d6cfe0","116":"6f6df1fe","117":"31d6cfe0","118":"31d6cfe0","119":"31d6cfe0","120":"6f6df1fe","121":"31d6cfe0","122":"31d6cfe0","123":"31d6cfe0","124":"6f6df1fe","125":"6f6df1fe","126":"31d6cfe0","127":"31d6cfe0","128":"31d6cfe0","129":"4b48318c","130":"4b48318c","131":"31d6cfe0","132":"31d6cfe0","133":"31d6cfe0","134":"4b48318c","135":"4b48318c","136":"4b48318c","137":"4b48318c","138":"4b48318c","139":"4b48318c","140":"4b48318c","141":"4b48318c","142":"4b48318c","143":"4b48318c","144":"4b48318c","145":"4b48318c","146":"4b48318c","147":"4b48318c","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0","155":"31d6cfe0","156":"31d6cfe0","157":"31d6cfe0","158":"31d6cfe0","159":"5fe6802c","160":"5fe6802c","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0","172":"31d6cfe0","173":"31d6cfe0","174":"31d6cfe0","175":"31d6cfe0","176":"31d6cfe0","177":"31d6cfe0","178":"31d6cfe0","179":"31d6cfe0","180":"31d6cfe0","181":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
